import React, { useEffect } from "react"
import TableCell from "@mui/material/TableCell"
import TableRow from "@mui/material/TableRow"
import Button from "@mui/material/Button"
import IconButton from "@mui/material/IconButton"
import Typography from "@mui/material/Typography"
import GroupIcon from "@mui/icons-material/Group"
import ContentCopyIcon from "@mui/icons-material/ContentCopy"
import { useGetAllInterviewsQuery } from "../../../api/InterviewsApi"
import { Alert, Box, CircularProgress, Stack, Tooltip } from "@mui/material"
import { useSelector } from "react-redux/es/hooks/useSelector"
import { useDispatch } from "react-redux/es/hooks/useDispatch"
import { RootState } from "../../../../../app/store"
import {
  setInterviewsTotalPages,
  setInterviewsTotalItems,
} from "../tablePagination/model/pagination"
import dayjs from "dayjs"
import { useSearchParams } from "react-router-dom"
import {
  setInterviewGroupState,
  setInterviewModeState,
  setInterviewRowState,
} from "../../create/dialogs/model/Interviews"
import NoRowsOverlay from "../../../../../shared/ui/NoRowsOverlay"
import SettingsIcon from "@mui/icons-material/Settings"
import { useLocation } from "react-router-dom"

const InterviewsRow = ({ open, setOpen }: any) => {
  const [searchParams] = useSearchParams()

  const period = searchParams.get("period") || "all"
  const dispatch = useDispatch()

  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const status = queryParams.get("status")
  const graphType = queryParams.get("graphType")
  const department = queryParams.get("department")
  const project = queryParams.get("project")
  const line = queryParams.get("line")
  const massRecruiter = queryParams.get("massRecruiter")
  const interviewer = queryParams.get("interviewer")
  const training = queryParams.get("training")
  const search = queryParams.get("search")
  const startDate = queryParams.get("startDate")
  const endDate = queryParams.get("endDate")

  const pagination = useSelector((state: RootState) => state.pagination)

  let query = `${pagination?.InterviewsPage}&period=${period}`
  if (status) {
    query += `&status=${status}`
  }
  if (graphType) {
    query += `&graphType=${graphType}`
  }
  if (department) {
    query += `&department=${department}`
  }
  if (project) {
    query += `&project=${project}`
  }
  if (line) {
    query += `&line=${line}`
  }
  if (massRecruiter) {
    query += `&massRecruiter=${massRecruiter}`
  }
  if (interviewer) {
    query += `&interviewer=${interviewer}`
  }
  if (training) {
    query += `&training=${training}`
  }

  if (startDate) {
    query += `&startDate=${startDate}`
  }
  if (endDate) {
    query += `&endDate=${endDate}`
  }
  if (search) {
    query += `&search=${search}`
  }

  const interviews = useGetAllInterviewsQuery(query)

  useEffect(() => {
    if (interviews.isSuccess) {
      dispatch(setInterviewsTotalItems(interviews?.data?.totalItems))
      dispatch(setInterviewsTotalPages(interviews?.data?.totalPages))
    }
  }, [interviews])

  const [isCopied, setIsCopied] = React.useState<number | null>()

  if (interviews.error) {
    return (
      <TableRow>
        <Alert severity="error"> Произошла ошибка</Alert>
      </TableRow>
    )
  }

  if (interviews.isLoading) {
    return (
      <TableRow
        sx={{
          "&:hover ": {
            bgcolor: "transparent !important",
          },
        }}
      >
        <Stack
          sx={{
            position: "sticky",
            top: "calc(50%)",
            display: "flex",
            alignItems: "center",
          }}
        >
          <CircularProgress />
        </Stack>
      </TableRow>
    )
  }

  return (
    <>
      {interviews.data?.data.map((interviewGroup: any) => (
        <React.Fragment key={interviewGroup?.id}>
          {interviewGroup?.data.slice(0, 1).map((row: any, index: number) => (
            <TableRow
              key={row.id}
              hover
              sx={{
                borderBottom: (theme) =>
                  theme.palette.mode === "light"
                    ? "10px solid rgba(255, 255, 255, 1)"
                    : "10px solid #272626",
                borderTop: (theme) =>
                  theme.palette.mode === "light"
                    ? "10px solid rgba(255, 255, 255, 1)"
                    : "10px solid #272626",

                borderRadius: "4px",
                height: "54px",
                "&:hover .iconButton": {
                  opacity: 1,
                },
              }}
            >
              <TableCell
                sx={{
                  bgcolor: "#ddeadc",
                  borderRadius: "4px",
                  boxSizing: "border-box",
                  minWidth: "68px",
                }}
              >
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent={"space-between"}
                >
                  <Box>{row.id}</Box>
                </Stack>
              </TableCell>
              <TableCell>
                {index === 0 &&
                  row.interviewDateTime &&
                  dayjs.utc(row.interviewDateTime).format("DD.MM HH:mm")}
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor:
                    interviewGroup.data.length === 1 ? "#ddeadc" : "#E0F2CA",
                  borderRadius: "4px",
                  minWidth: "242px",
                }}
              >
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent={"space-between"}
                >
                  <Typography
                    sx={{
                      minWidth: "100px",
                      lineHeight: "1",
                      color:
                        interviewGroup.data.length === 1 ? "" : "primary.main",
                    }}
                  >
                    {interviewGroup.data.length === 1
                      ? row.personalInformation.fullName
                      : "Посмотреть всех участников"}
                  </Typography>
                  <Button
                    size="small"
                    sx={{
                      maxWidth: "25px !important",
                      maxHeight: "25px !important",
                      minWidth: "0px !important",
                      minHeight: "0px !important",
                    }}
                    onClick={() => {
                      dispatch(setInterviewModeState({ mode: "edit" }))
                      interviewGroup.data.length === 1
                        ? dispatch(setInterviewRowState(row))
                        : dispatch(setInterviewGroupState(interviewGroup))

                      interviewGroup.data.length === 1
                        ? setOpen({ ...open, openCreateInterwiew: true })
                        : setOpen({ ...open, openInterviewsDialog: true })
                    }}
                    variant="outlined"
                  >
                    <GroupIcon fontSize="small" />
                  </Button>
                </Stack>
              </TableCell>
              <TableCell
                sx={{
                  whiteSpace: "nowrap",
                  position: "relative",
                  "&:hover .iconButton": {
                    opacity: 1,
                  },
                  pr: "10px !important",
                  mr: "-10px !important",
                }}
              >
                <Tooltip
                  followCursor
                  title={
                    <Stack sx={{ minWidth: "900px" }}>
                      <Typography fontSize={12}>
                        Собеседование в поддержку сервиса {row.project.name}.
                      </Typography>
                      <Typography fontSize={12}>
                        Дата:{" "}
                        {row.interviewDateTime &&
                          `${dayjs
                            .utc(row.interviewDateTime)
                            .format("DD.MM HH:mm")} (по МСК)`}
                        .<br />
                      </Typography>

                      <Typography
                        sx={{
                          color: "black",

                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                        width={"290px"}
                        fontSize={12}
                      >
                        Ссылка на встречу:{" "}
                        {row.interviewType.name === "Групповое"
                          ? row.interviewer.groupLink
                          : row.interviewer.individualLink}{" "}
                      </Typography>
                    </Stack>
                  }
                  arrow
                >
                  <Stack
                    direction={"row"}
                    alignItems={"center"}
                    justifyContent={"center"}
                  >
                    {index === 0 && row.interviewer.name}
                    {isCopied === row.id && (
                      <Stack
                        sx={{
                          minWidth: "100px",
                          bgcolor: "rgba(232, 245, 231, 1)",
                          position: "absolute",

                          textAlign: "center",
                          alignItems: "center",
                          height: "100%",
                          width: "100%",
                          borderRadius: " 0px 4px 4px 0px",
                        }}
                        alignItems={"center"}
                        justifyContent={"flex-start"}
                        direction={"row"}
                      >
                        <Typography
                          sx={{ pl: "10px !important", color: "primary.main" }}
                        >
                          Скопировано
                        </Typography>
                      </Stack>
                    )}
                    {row.interviewer.name && (
                      <IconButton
                        className="iconButton"
                        sx={{
                          backgroundColor: "rgba(232, 245, 231, 1)",
                          opacity: 0,
                          transition: "opacity 0.3s",
                        }}
                        onClick={() => {
                          setIsCopied(row.id)
                          navigator.clipboard.writeText(
                            `Собеседование в поддержку сервиса ${row.project.name}\n` +
                              `Дата: ${
                                row.interviewDateTime &&
                                dayjs
                                  .utc(row.interviewDateTime)
                                  .format("DD.MM HH:mm")
                              }\n` +
                              `Собеседующий: ${row.interviewer.name}\n` +
                              `Ссылка на встречу: ${
                                row.interviewType.name === "Групповое"
                                  ? row.interviewer.groupLink
                                  : row.interviewer.individualLink
                              }`,
                          )

                          setTimeout(() => {
                            setIsCopied(null)
                          }, 2000)
                        }}
                        size="small"
                      >
                        <ContentCopyIcon
                          sx={{ color: "rgb(23,23,23,0.3)" }}
                          fontSize="small"
                        />
                      </IconButton>
                    )}
                  </Stack>
                </Tooltip>
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>
                {index === 0 && row.interviewType.name}
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>
                {row.graphType?.name}
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>
                <Typography
                  sx={{ fontSize: 14, lineHeight: "1.2", fontWeight: "bold" }}
                >
                  {`${row.schedule.pattern ? row.schedule.pattern : ""} ${
                    row.schedule.startDate
                      ? `${dayjs(row.schedule.startDate)
                          .utc()
                          .format("HH:mm")} -`
                      : ""
                  }   ${
                    row.schedule.endDate
                      ? dayjs(row.schedule.endDate).utc().format("HH:mm")
                      : ""
                  }`}{" "}
                </Typography>
                <Typography sx={{ fontSize: 14, lineHeight: "1.2" }}>
                  {(row.workDays?.startDate || row.workDays?.endDate) &&
                    `${dayjs(row.workDays?.startDate).utc().format("DD.MM")} -
            ${dayjs(row.workDays?.endDate).utc().format("DD.MM")} `}
                </Typography>
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>
                {`${
                  row.workDays.startDate
                    ? dayjs(row.workDays.startDate).utc().format("DD.MM")
                    : ""
                } ${
                  row.workDays.endDate
                    ? dayjs(row.workDays.endDate).utc().format("DD.MM")
                    : ""
                } `}
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>
                {row.project.name}
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>
                {dayjs.utc(row.created).format("DD.MM HH:mm")}
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>
                {row.department.name}
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>
                {row.line.name}
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>
                {row.massRecruiter.name}
              </TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>
                {row.status.name}
              </TableCell>

              <IconButton
                onClick={() => {
                  dispatch(setInterviewModeState({ mode: "edit" }))
                  interviewGroup.data.length === 1
                    ? dispatch(setInterviewRowState(row))
                    : dispatch(setInterviewGroupState(interviewGroup))

                  interviewGroup.data.length === 1
                    ? setOpen({ ...open, openCreateInterwiew: true })
                    : setOpen({ ...open, openInterviewsDialog: true })
                }}
                sx={{
                  backgroundColor: "rgba(232, 245, 231, 1)",
                  opacity: 0,
                  transition: "opacity 0.3s",
                  position: "sticky",
                  right: "0px",
                  top: "10px",
                  height: "52px",
                  bgcolor: "rgba(232, 245, 231, 1)",
                  borderRadius: "4px",
                  minWidth: "54px",
                  border: "1px solid #1B9C18",
                  ":hover": {
                    backgroundColor: "rgba(232, 245, 231, 1)",
                    opacity: 1,
                  },
                }}
                className="iconButton"
                size="small"
              >
                <SettingsIcon color="primary" sx={{ borderRadius: "4px" }} />
              </IconButton>
            </TableRow>
          ))}
        </React.Fragment>
      ))}

      {interviews.data?.data.length === 0 && <NoRowsOverlay />}
      {interviews?.data?.item !== 8 &&
        Array.from({
          length: Math.max(0, 8 - interviews.data.data.length),
        }).map((_, index) => <TableRow key={index}></TableRow>)}
    </>
  )
}

export default InterviewsRow
